import { formatMoney } from "../../utils/format";

// Orders are in taka (as in the storefront)
export const formatTaka = (value) => `৳ ${formatMoney(+value || 0)}`;

// money is kept to 2 decimals: 6838.63 - 0 must not come out as 6838.629999999999
export const round2 = (value) => Math.round(((+value || 0) + Number.EPSILON) * 100) / 100;

export const getTotal = (order) => round2(order?.state?.totalAmount);
export const getPaid = (order) => round2(order?.paidAmount);
export const getDue = (order) => Math.max(0, round2(getTotal(order) - getPaid(order)));
